export default __webpack_public_path__ + "static/media/ad-mi-plan.597a877b.png";